<template>
    <v-container fluid class="container-full-bg-gray" >
        <v-dialog v-if="detail_pop_up" v-model="detail_pop_up" max-width="800">
            <v-card class="pa-6">
                <v-card-title class="font-weight-bold">
                    {{ entity_type.name }}
                </v-card-title>
                <InstanceEditorV1 
                    v-if="editor_ui && selected_instance"
                    :my_ui="editor_ui.payload" 
                    v-model="selected_instance"
                    readonly />
            </v-card>
        </v-dialog>
        <v-row v-if="query_schema && query_schema.properties && Object.keys(query_schema.properties).length > 0">
            <v-col cols="10" >
            <RecursivePayloadOnSchemaEditor 
                
                :schema="query_schema" 
                :key_to_show="'Parámetros'"
                v-model="my_query"
                @change="refreshList"
            />
            </v-col>
            <!-- <v-col cols="2">
                <v-btn @click="refreshList" 
                        icon
                        color="primary"
                        class="mr-2"
                        style="top: 10px;"
                        icon
                        
                        >
                    <v-icon size="x-large">mdi-refresh</v-icon>
                </v-btn>
            </v-col> -->
        </v-row>
        <v-row v-if="my_ui && my_ui.entity_type_id == '00004d7a-e4fe-47af-8ff6-187bca92f301'">
            <v-col cols="12">
                <ListViewerV0 :my_ui="my_ui.payload" :list_of_instances="list_of_instances" 
                              :key="key_for_list"
                              :loading="loadingList"
                              @row-click="rowClick"
                              @refresh="refreshList"/>
            </v-col>
        </v-row>
    </v-container>
    
</template>
  
<script>
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import { EntityTypeApiRepository,  EntityInstanceApiRepository} from "@/modules/entities/infra/EntitiesApiRepositories";
import { EntitiesListScreenData} from "@/modules/entities/domain/EntitiesListScreenData";
import { EntitiesListComponent } from "@/modules/entities/app/EntitiesListComponent";
import { mapGetters, mapState } from "vuex";
import AppSearchBar from '@/components/layout/AppSearchBar.vue';
import { filter } from "mathjs";
import { document_components_factory } from "@/api/client";
import ListViewerV0 from "@/modules/entities/infra/UIComponents/ListViewerV0.vue";
import RecursivePayloadOnSchemaEditor from "@/modules/entities/infra/RecursivePayloadOnSchemaEditor.vue";
import InstanceEditorV1 from "@/modules/entities/infra/UIComponents/InstanceEditorV1.vue";
  
export default {
    name: "EntitiesListUIs",
    components: {
        AppBtn,
        AppCol,
        AppRow,
        AppSearchBar,
        ListViewerV0,
        RecursivePayloadOnSchemaEditor,
        InstanceEditorV1
    },
    data() {
        return {
            list_of_instances: [],
            entity_type: null,
            my_ui:null,
            my_query: {},
            editor_ui: null,
            query_schema:{},
            call_id: 0,
            selected_instance: null,
            detail_pop_up: false,
            loadingList: false,
            mounted: false,
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
            default: null
        },
        entity_type_id: {
            type: [Number, String],
            required: true,
            default: null
        }
    },
    watch: { 
        companydb_id: function() {
            if (this.mounted){
                this.fetchInstances()
            }
            
        }
    },
    computed: {
        key_for_list() {
            return this.list_of_instances.length.toString() + this.call_id.toString();
        },
    },
    methods: {
        async fetchInstances() {
            this.loadingList = true;
            this.list_of_instances = await new EntityInstanceApiRepository().runWorkflowByParamsType(this.my_query, this.my_ui.payload.refresh_query_type, this.companydb_id);
            this.call_id = this.call_id + 1 
            if (!this.list_of_instances){
                this.list_of_instances = []
            }
            this.loadingList = false;
        },
        rowClick(row) {
        //     console.log('rowClick',row)
        //     this.$router.push({ name: 'entity-instance-editor', params: { companydb_id: this.companydb_id, entity_instance_id: row.uuid } })
            if (this.editor_ui){
                this.selected_instance = row;
                this.detail_pop_up = true;
            }
        },
        refreshList(e) {
            console.log('refreshList', e)
            this.fetchInstances()
        },

    },
    async mounted() {
        this.entity_type = await new EntityTypeApiRepository().get_type_by_id(this.entity_type_id)
        if (this.entity_type.ui_config && this.entity_type.ui_config.entity_list_viewer){
            this.my_ui = (await new EntityInstanceApiRepository().get_instance_by_id(this.entity_type.ui_config.entity_list_viewer))
            let query_schema_id = this.my_ui.payload.refresh_query_type
            let query_type = await new EntityTypeApiRepository().get_type_by_id(query_schema_id)
            this.query_schema = query_type.schema
        }
        if (this.entity_type.ui_config && this.entity_type.ui_config.entity_editor){
            this.editor_ui = await new EntityInstanceApiRepository().get_instance_by_id(this.entity_type.ui_config.entity_editor)
            console.log(this.entity_type.ui_config.entity_editor)
            console.log('editor_ui', this.editor_ui)
        }
        this.refreshList();
        this.mounted = true;
    },
  
};
</script>

<style scoped>

::v-deep .v-card__title {
    padding-top: 15px !important;
    padding-bottom: 15px !important;

}
/*.card-title-footer-color {
    background: #fafaff;
}

::v-deep .v-data-footer {
    background-color: #fafaff;
    margin-right: 0px !important;
    padding-right: 17px;
}*/

::v-deep .v-data-table-header>tr>th {
    background-color: var(--v-primaryLight-base) !important;
}

::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}

::v-deep tbody tr:nth-of-type(even) {
    /* 'deep-orange lighten-5' basides on material design color */
    background-color: rgba(245, 245, 245, 0.47);
}

::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}

.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 36px 20px;
}

.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}
</style>
  